<title>Unauthorized Access</title>
<div class="error-page">
    <div class="error-image">
        <img class="img-fluid" src="assets/images/illustration/error401.svg" alt="Error page" />
    </div>
    <div class="error-message">
        <img class="oops-img" src="assets/images/illustration/Oops.svg" alt="Error page" />
        <p>Accès non autorisé.</p>
    </div>
</div>